import { render, staticRenderFns } from "./video.datatable.vue?vue&type=template&id=843ded54&scoped=true&"
import script from "./video.datatable.vue?vue&type=script&lang=js&"
export * from "./video.datatable.vue?vue&type=script&lang=js&"
import style0 from "./video.datatable.vue?vue&type=style&index=0&id=843ded54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843ded54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
